import './en';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/danfostersmith/Documents/GitHub/crossing-borders/node_modules/ngx-bootstrap/bs-moment/locale/index.js
// module id = ../../../../ngx-bootstrap/bs-moment/locale/index.js
// module chunks = vendor